"use strict";
var $a5fd07fa01589658$exports = {};
"use strict";
class $a5fd07fa01589658$var$Game {
    static gameStatus = {
        idle: "idle",
        playing: "playing",
        win: "win",
        lose: "lose"
    };
    constructor(initialState = [
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ]
    ]){
        this.initialState = initialState;
        this.score = 0;
        this.status = $a5fd07fa01589658$var$Game.gameStatus.idle;
        this.state = initialState.map((row)=>[
                ...row
            ]);
    }
    getRandomCell() {
        const emptyCells = [];
        for(let row = 0; row < 4; row++){
            for(let col = 0; col < 4; col++)if (this.state[row][col] === 0) emptyCells.push([
                row,
                col
            ]);
        }
        if (emptyCells.length > 0) {
            const randomIndex = Math.floor(Math.random() * emptyCells.length);
            const [randomRow, randomCol] = emptyCells[randomIndex];
            this.state[randomRow][randomCol] = Math.random() < 0.9 ? 2 : 4;
        }
    }
    checkStatus() {
        let hasEmptyCells = false;
        let canMove = false;
        for(let row = 0; row < 4; row++)for(let col = 0; col < 4; col++){
            const cellValue = this.state[row][col];
            if (cellValue === 2048) {
                if (this.status !== $a5fd07fa01589658$var$Game.gameStatus.win) this.status = $a5fd07fa01589658$var$Game.gameStatus.win;
            }
            if (cellValue === 0) hasEmptyCells = true;
            if (row < 3 && cellValue === this.state[row + 1][col] || col < 3 && cellValue === this.state[row][col + 1]) canMove = true;
        }
        if (!hasEmptyCells && !canMove) this.status = $a5fd07fa01589658$var$Game.gameStatus.lose;
    }
    moveLeft() {
        const previousState = this.state.map((row)=>row.slice());
        for(let row = 0; row < 4; row++){
            const newRow = this.state[row].filter((val)=>val !== 0);
            const mergedRow = [];
            for(let i = 0; i < newRow.length; i++)if (newRow[i] === newRow[i + 1]) {
                mergedRow.push(newRow[i] * 2);
                this.score += newRow[i] * 2;
                i++;
            } else mergedRow.push(newRow[i]);
            this.state[row] = mergedRow.concat(Array(4 - mergedRow.length).fill(0));
        }
        this.checkForChanges(previousState);
        this.checkStatus();
    }
    moveRight() {
        const previousState = this.state.map((row)=>row.slice());
        for(let row = 0; row < 4; row++){
            const newRow = this.state[row].filter((val)=>val !== 0).reverse();
            const mergedRow = [];
            for(let i = 0; i < newRow.length; i++)if (newRow[i] === newRow[i + 1]) {
                mergedRow.push(newRow[i] * 2);
                this.score += newRow[i] * 2;
                i++;
            } else mergedRow.push(newRow[i]);
            this.state[row] = Array(4 - mergedRow.length).fill(0).concat(mergedRow.reverse());
        }
        this.checkForChanges(previousState);
        this.checkStatus();
    }
    moveUp() {
        this.state = this.transpose(this.state);
        this.moveLeft();
        this.state = this.transpose(this.state);
    }
    moveDown() {
        this.state = this.transpose(this.state);
        this.moveRight();
        this.state = this.transpose(this.state);
    }
    transpose(state) {
        const result = [];
        for(let col = 0; col < 4; col++){
            result[col] = [];
            for(let row = 0; row < 4; row++)result[col].push(state[row][col]);
        }
        return result;
    }
    checkForChanges(previousState) {
        if (this.state.toString() !== previousState.toString()) {
            this.getRandomCell();
            this.status = $a5fd07fa01589658$var$Game.gameStatus.playing;
        }
    }
    getScore() {
        return this.score;
    }
    getState() {
        return this.state;
    }
    getStatus() {
        return this.status;
    }
    start() {
        this.status = $a5fd07fa01589658$var$Game.gameStatus.playing;
        this.getRandomCell();
    }
    restart() {
        this.state = this.initialState.map((row)=>[
                ...row
            ]);
        this.score = 0;
        this.status = $a5fd07fa01589658$var$Game.gameStatus.idle;
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports();
const $09e991522ca7e64e$var$startButton = document.querySelector(".start");
const $09e991522ca7e64e$var$gameScore = document.querySelector(".game-score");
const $09e991522ca7e64e$var$gameField = document.querySelector(".game-field");
const $09e991522ca7e64e$var$messageLose = document.querySelector(".message-lose");
const $09e991522ca7e64e$var$messageWin = document.querySelector(".message-win");
const $09e991522ca7e64e$var$messageStart = document.querySelector(".message-start");
$09e991522ca7e64e$var$startButton.addEventListener("click", ()=>{
    if ($09e991522ca7e64e$var$startButton.classList.contains("start")) {
        $09e991522ca7e64e$var$game.start();
        $09e991522ca7e64e$var$startButton.classList.remove("start");
        $09e991522ca7e64e$var$startButton.classList.add("restart");
        $09e991522ca7e64e$var$startButton.textContent = "Restart";
        $09e991522ca7e64e$var$messageStart.classList.add("hidden");
        $09e991522ca7e64e$var$messageLose.classList.add("hidden");
        $09e991522ca7e64e$var$messageWin.classList.add("hidden");
    } else if ($09e991522ca7e64e$var$startButton.classList.contains("restart")) {
        $09e991522ca7e64e$var$game.restart();
        $09e991522ca7e64e$var$startButton.classList.remove("restart");
        $09e991522ca7e64e$var$startButton.classList.add("start");
        $09e991522ca7e64e$var$startButton.textContent = "Start";
        $09e991522ca7e64e$var$messageStart.classList.remove("hidden");
        $09e991522ca7e64e$var$messageLose.classList.add("hidden");
        $09e991522ca7e64e$var$messageWin.classList.add("hidden");
    }
    $09e991522ca7e64e$var$updateGameField();
    $09e991522ca7e64e$var$setScore();
});
document.addEventListener("keyup", (e)=>{
    const moves = {
        ArrowRight: $09e991522ca7e64e$var$game.moveRight,
        ArrowLeft: $09e991522ca7e64e$var$game.moveLeft,
        ArrowUp: $09e991522ca7e64e$var$game.moveUp,
        ArrowDown: $09e991522ca7e64e$var$game.moveDown
    };
    if (moves[e.key]) moves[e.key].call($09e991522ca7e64e$var$game);
    $09e991522ca7e64e$var$updateGameField();
    $09e991522ca7e64e$var$setScore();
    $09e991522ca7e64e$var$setMessage();
});
function $09e991522ca7e64e$var$updateGameField() {
    $09e991522ca7e64e$var$gameField.innerHTML = "";
    const currentState = $09e991522ca7e64e$var$game.getState();
    for(let row = 0; row < 4; row++){
        const tr = document.createElement("tr");
        for(let col = 0; col < 4; col++){
            const td = document.createElement("td");
            const value = currentState[row][col];
            td.textContent = value !== 0 ? value : "";
            td.classList.add("field-cell");
            if (value !== 0) td.classList.add(`field-cell--${value}`);
            tr.appendChild(td);
        }
        $09e991522ca7e64e$var$gameField.appendChild(tr);
    }
}
function $09e991522ca7e64e$var$setScore() {
    if ($09e991522ca7e64e$var$gameScore) $09e991522ca7e64e$var$gameScore.textContent = $09e991522ca7e64e$var$game.getScore();
}
function $09e991522ca7e64e$var$setMessage() {
    const currStatus = $09e991522ca7e64e$var$game.getStatus();
    $09e991522ca7e64e$var$messageWin.classList.toggle("hidden", currStatus !== $a5fd07fa01589658$exports.gameStatus.win);
    $09e991522ca7e64e$var$messageLose.classList.toggle("hidden", currStatus !== $a5fd07fa01589658$exports.gameStatus.lose);
}
$09e991522ca7e64e$var$updateGameField();
$09e991522ca7e64e$var$setMessage();
$09e991522ca7e64e$var$setScore();


//# sourceMappingURL=index.3994a63d.js.map
